/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useRef, useState } from "react";
import { FaCheckDouble, FaCircleNotch, FaListOl, FaTimes } from "react-icons/fa";

// api
import activitiesApi from "../../api/Activities";

//css
import "../dashboard/Dashboard.css";

//components
import Card from "../../components/card/Card";
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import StatCard from "../../components/statcard/StatCard";

//data
import { empty, errorResponse, isArray, isObject, prepareResponseData } from "../../Utilities/utils";
import { AuthContext } from "../Root/ProtectedRoute";
import { Toast } from "primereact/toast";
import { useEffect } from "react";
import BoxLoading from "../../components/skeleton/BoxLoading";
import colors from "../../config/colors";
import ActivitiesWrapper from "../../components/appWrapper/ActivitiesWrapper";
import TableLoading from "../../components/skeleton/TableLoading";
import EmptyListResponse from "../../components/emptyDiv/EmptyListResponse";
import DoughnutChart from "../../components/chart/doughnut/DoughnutChart";
import DonutChartLoading from "../../components/skeleton/DonutChartLoading";
import ActivitiesList from "../../components/lists/activities/ActivitiesList";

const ActivitiesDashboard = ({ ...props }) => {
  const { user } = useContext(AuthContext);
  // stat status
  const [isActivitiesStatLoading, setIsActivitiesStatLoading] =
    useState(false);
  const [activitiesStatusCount, setActivitiesStatusCount] = useState({});
  const [isActivitiesStatListsLoading, setIsActivitiesStatListsLoading] = useState(false);
  const [activitiesStatusLists, setActivitiesStatusLists] = useState([]);

  const toastTR = useRef(null);

  useEffect(() => {
    getActivitiesStatusCount();
    getActivitiesStatusLists();
  }, []);

  // alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR?.current?.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  const getActivitiesStatusCount = async () => {
     if (isActivitiesStatLoading) setIsActivitiesStatLoading(true);
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await activitiesApi.getActivitiesStatusCount(
        schoolId
      );
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data.response)
            ? typeof response_data.response === "string"
              ? response_data.response
              : "Failed to fetch activities status counts!"
            : "Failed to fetch activities status counts"
        );
      }

      const data =
        isObject(response_data?.response)
          ? response_data.response
          : {};
      setActivitiesStatusCount(data);
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsActivitiesStatLoading(false);
    }
  };


  const getActivitiesStatusLists = async () => {
     if (isActivitiesStatListsLoading) setIsActivitiesStatListsLoading(true);
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await activitiesApi.getActivitiesStatusLists(
        schoolId
      );
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data.response)
            ? typeof response_data.response === "string"
              ? response_data.response
              : "Failed to fetch activities status lists!"
            : "Failed to fetch activities status lists"
        );
      }

      const data =
        isObject(response_data?.response)
          ? response_data.response
          : {};
      setActivitiesStatusLists(data);
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsActivitiesStatListsLoading(false);
    }
  };

  return (
    <>
      <ActivitiesWrapper {...props}>
        <main>
          {/* menu header */}
          <MainHeader title="Activities Dashboard" />
          {/* end menu header */}
          <div
            className="mt-10"
            style={{ display: "flex", flexDirection: "row" }}
          >
            {/* left box */}
            <div className="w-100pc">
              {/* stat box */}
              <div className="top_stat_box">
                <Card
                  children={
                    !isActivitiesStatLoading ? (
                      <StatCard
                        underlineWidth={15}
                        bgColor={colors.primary}
                        title="#Total Activities"
                        entry={activitiesStatusCount?.['Total']?.count || 0}
                        icon={
                          <FaListOl size={14} className="stat_card_icon" />
                        }
                      />
                    ) : (
                      <BoxLoading />
                    )
                  }
                  addStyle="card_adjust_stat"
                />
                <Card
                  children={
                    !isActivitiesStatLoading ? (
                      <StatCard
                        underlineWidth={15}
                        bgColor={colors.primary}
                        title="#Active Activities"
                        entry={activitiesStatusCount?.['Active']?.count || 0}
                        icon={
                          <FaCircleNotch size={14} className="stat_card_icon" />
                        }
                      />
                    ) : (
                      <BoxLoading />
                    )
                  }
                  addStyle="card_adjust_stat"
                />
                <Card
                  children={
                    !isActivitiesStatLoading ? (
                      <StatCard
                        underlineWidth={15}
                        bgColor={colors.primary}
                        title="#Cancelled Activities"
                        entry={activitiesStatusCount?.['Cancelled']?.count || 0}
                        icon={
                          <FaTimes size={14} className="stat_card_icon" />
                        }
                      />
                    ) : (
                      <BoxLoading />
                    )
                  }
                  addStyle="card_adjust_stat"
                />
                <Card
                  children={
                    !isActivitiesStatLoading ? (
                      <StatCard
                        underlineWidth={15}
                        bgColor={colors.primary}
                        title="#Pending Activities"
                        entry={activitiesStatusCount?.['Pending']?.count || 0}
                        icon={
                          <FaCheckDouble size={14} className="stat_card_icon" />
                        }
                      />
                    ) : (
                      <BoxLoading />
                    )
                  }
                  addStyle="card_adjust_stat"
                />
                <Card
                  children={
                    !isActivitiesStatLoading ? (
                      <StatCard
                        underlineWidth={15}
                        bgColor={colors.primary}
                        title="#Completed Activities"
                        entry={activitiesStatusCount?.['Completed']?.count || 0}
                        icon={
                          <FaCheckDouble size={14} className="stat_card_icon" />
                        }
                      />
                    ) : (
                      <BoxLoading />
                    )
                  }
                  addStyle="card_adjust_stat"
                />
              </div>
              {/* stat header end */}


              <div className="inner_chart_box">
                <Card
                  children={
                    <>
                      <MainHeader title="Activities Chart" />
                      {!isActivitiesStatLoading ? (
                        <DoughnutChart
                          doughnutData={[
                            activitiesStatusCount?.['Completed']?.count || 10,
                            activitiesStatusCount?.['Cancelled']?.count || 20,
                            activitiesStatusCount?.['Active']?.count || 30,
                            activitiesStatusCount?.['Pending']?.count
                          ]}
                          label1="Complete"
                          label2="Cancelled"
                          label3="Active"
                          label4="Pending"
                        />
                      ) : (
                        <DonutChartLoading />
                      )}
                    </>
                  }
                  addStyle="donut_chart_box"
                />
                <Card
                  children={
                    <>
                      <MainHeader title="Recent Activities" />
                      <div className="dashboard_school_list">
                        {!isActivitiesStatListsLoading &&
                          !empty(activitiesStatusLists?.['Newest']?.activities) && isArray(activitiesStatusLists?.['Newest']?.activities) ? (activitiesStatusLists?.['Newest']?.activities.map((activity, index) => {
                            return (
                              <ActivitiesList key={activity?._id || index} data={activity} link={`/activity/${activity?._id}/update`} />
                            );
                          })
                        ) : empty(activitiesStatusLists?.['Newest']?.activities) ? (
                          <EmptyListResponse />
                        ) : (
                          <TableLoading rows={20} cols={1} header={false} />
                        )}
                      </div>
                    </>
                  }
                  id="chart_box2"
                />
                <Card
                  children={
                    <>
                      <MainHeader title="Active Activities" />
                      <div className="dashboard_school_list">
                        {!isActivitiesStatListsLoading &&
                          !empty(activitiesStatusLists?.['Active']?.activities) && isArray(activitiesStatusLists?.['Active']?.activities) ? (activitiesStatusLists?.['Active']?.activities.map((activity, index) => {
                            return (
                              <ActivitiesList key={activity?._id || index} data={activity} link={`/activity/${activity?._id}/update`} />
                            );
                          }))
                          : empty(activitiesStatusLists?.['Active']?.activities) ? (
                          <EmptyListResponse />
                        ) : (
                          <TableLoading rows={20} cols={1} header={false} />
                        )}
                      </div>
                    </>
                  }
                  addStyle="ongoing_activities"
                />
              </div>

              <div className="inner_chart_box">
                <Card
                  children={
                    <>
                      <MainHeader title="Pending Activities" />
                      <div className="dashboard_school_list">
                        {!isActivitiesStatListsLoading &&
                          !empty(activitiesStatusLists?.['Pending']?.activities) && isArray(activitiesStatusLists?.['Pending']?.activities) ? (activitiesStatusLists?.['Pending']?.activities.map((activity, index) => {
                            return (
                              <ActivitiesList key={activity?._id || index} data={activity} link={`/activity/${activity?._id}/update`} />
                            );
                          }))
                          : empty(activitiesStatusLists?.['Pending']?.activities) ? (
                          <EmptyListResponse />
                        ) : (
                          <TableLoading rows={20} cols={1} header={false} />
                        )}
                      </div>
                    </>
                  }
                  addStyle="ongoing_activities"
                />
                <Card
                  children={
                    <>
                      <MainHeader title="Completed Activities" />
                      <div className="dashboard_school_list">
                        {!isActivitiesStatListsLoading &&
                          !empty(activitiesStatusLists?.['Completed']?.activities) && isArray(activitiesStatusLists?.['Completed']?.activities) ? (activitiesStatusLists?.['Completed']?.activities.map((activity, index) => {
                            return (
                              <ActivitiesList key={activity?._id || index} data={activity} link={`/activity/${activity?._id}/update`} />
                            );
                          }))
                          : empty(activitiesStatusLists?.['Completed']?.activities) ? (
                          <EmptyListResponse />
                        ) : (
                          <TableLoading rows={20} cols={1} header={false} />
                        )}
                      </div>
                    </>
                  }
                  id="chart_box2"
                />
                <Card
                  children={
                    <>
                      <MainHeader title="Cancelled Activities" />
                      <div className="dashboard_school_list">
                        {!isActivitiesStatListsLoading &&
                          !empty(activitiesStatusLists?.['Cancelled']?.activities) && isArray(activitiesStatusLists?.['Cancelled']?.activities) ? (activitiesStatusLists?.['Cancelled']?.activities.map((activity, index) => {
                            return (
                              <ActivitiesList key={activity?._id || index} data={activity} link={`/activity/${activity?._id}/update`} />
                            );
                          })
                        ) : empty(activitiesStatusLists?.['Cancelled']?.activities) ? (
                          <EmptyListResponse />
                        ) : (
                          <TableLoading rows={20} cols={1} header={false} />
                        )}
                      </div>
                    </>
                  }
                  id="chart_box2"
                />
              </div>
            </div>
          </div>
        </main>
        <Toast ref={toastTR} position="bottom-left" />
      </ActivitiesWrapper>
    </>
  );
};

export default ActivitiesDashboard;
